import { Component, Input } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'cv-current-hold-times',
    templateUrl: './current-hold-times.component.html',
    styleUrls: ['./current-hold-times.component.scss']
})
export class CurrentHoldTimesComponent {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;

    constructor(
        public config: CvConfigurationService
    ) {}
}
